module.exports = __webpack_public_path__ + "img/quin-dokters.4d2a5da3.jpeg";